<div class="sgc-root" #host>
  <app-gantt-chart
    [widgets]="widgetsConfig"
    [embeddedMode]="true"
    [compactLayout]="isFloatingView"
    [chartContainerId]="chartContainerId"
    [externalChartData]="data"
    [externalProgramData]="programData"
    [isFullscreen]="isFullscreen"
    (chartLayoutChanged)="onChartLayoutChanged($event)">
  </app-gantt-chart>
</div>
